function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { AllhomesListingBadges } from '@domain-group/fe-co-allhomes-listing-badges';
import { AllhomesListingCardAddress, AllhomesListingCardFeatures, AllhomesListingCardImages } from '../../components';
import * as styles from './default-listing-card.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var DefaultListingCard = props => {
  var _props$url;
  return ___EmotionJSX("div", {
    css: styles.container,
    className: props.className
  }, ___EmotionJSX("a", {
    className: "allhomes-listing-card__link",
    href: (_props$url = props.url) !== null && _props$url !== void 0 ? _props$url : undefined,
    id: "allhomes-listing-card-listing-".concat(props.id),
    onClick: () => {
      var _props$onClick;
      (_props$onClick = props.onClick) === null || _props$onClick === void 0 ? void 0 : _props$onClick.call(props, props.id);
    }
  }, ___EmotionJSX(AllhomesListingCardImages, _extends({
    css: styles.images
  }, props.images), ___EmotionJSX("div", {
    css: styles.badges
  }, ___EmotionJSX(AllhomesListingBadges, props.listingBadges))), ___EmotionJSX("div", {
    css: styles.details,
    className: "allhomes-listing-card__details"
  }, ___EmotionJSX("div", {
    css: styles.price
  }, ___EmotionJSX("span", {
    className: "allhomes-listing-card__details-price-main"
  }, props.price)), ___EmotionJSX(AllhomesListingCardAddress, _extends({}, props.address, {
    includeStructuredData: props.includeStructuredData
  })), ___EmotionJSX(AllhomesListingCardFeatures, _extends({
    css: styles.features
  }, props.features)))));
};